import { Component, EventEmitter, Output } from '@angular/core';
import { CustomFieldDto } from 'src/core/models/custom-field/custom-field.dto';
import { CrudService } from 'src/core/services/crud/crud.service';

@Component({
    selector: 'custom-field-delete-modal',
    templateUrl: './custom-field-delete-modal.component.html',
    styleUrl: './custom-field-delete-modal.component.scss',
})
export class CustomFieldDeleteModalComponent {
  @Output()
  onDeleted: EventEmitter<{}> = new EventEmitter();

  selectedCfId: number = 0;
  isModalOpen: boolean = false;
  
  constructor(private service: CrudService) {
  }

  delete(){ 
    this.service.delete(CustomFieldDto, this.selectedCfId).subscribe(() => {
      this.onDeleted.emit();
      this.isModalOpen = false;
    });
  }
}